// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4298":"css/app.6955","8650":"css/admin-app.6955"}[chunkId] + ".css";
};